"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _1 = require(".");

var ItemTypesRepo_1 = __importDefault(require("./repos/ItemTypesRepo"));

var DouanesRepo_1 = __importDefault(require("./repos/DouanesRepo"));

var MessagesRepo_1 = __importDefault(require("./repos/MessagesRepo"));

var PickingsRepo_1 = __importDefault(require("./repos/PickingsRepo"));

var SyncsRepo_1 = __importDefault(require("./repos/SyncsRepo"));

var CarriersRepo_1 = __importDefault(require("./repos/CarriersRepo"));

var Repos =
/** @class */
function () {
  function Repos(stitch, auth) {
    this.stitch = stitch;
    this.db = stitch.db;
    this.auth = auth;
    Repos.singleton = this;
  }

  Repos.repos = function () {
    return Repos.singleton;
  };

  Repos.prototype.getUsers = function () {
    return new _1.UsersRepo(this.db.collection("users"));
  };

  Repos.prototype.getOrgs = function () {
    return new _1.OrgsRepo(this.db.collection("orgs"), this.getMessages(), this.auth.getUser());
  };

  Repos.prototype.getItems = function () {
    return new _1.ItemsRepo(this.stitch.app, this.db.collection("items"), this.auth.getUser());
  };

  Repos.prototype.getOrders = function () {
    return new _1.OrdersRepo(this.db.collection("orders"), this.auth.getUser());
  };

  Repos.prototype.getFormats = function () {
    return new _1.FormatsRepo(this.db.collection("formats"), this.auth.getUser());
  };

  Repos.prototype.getItemTypes = function () {
    var _this = this;

    if (!this.itemTypes) {
      var handleChange = function handleChange() {
        _this.stitch.app.callFunction("hanedleItemTypesChange", []);
      };

      this.itemTypes = new ItemTypesRepo_1.default(this.db.collection("itemtypes"), this.auth.getUser());
      this.itemTypes.on("inserted", handleChange);
      this.itemTypes.on("updated", handleChange);
      this.itemTypes.on("deleted", handleChange);
    }

    return this.itemTypes;
  };

  Repos.prototype.getDouanes = function () {
    return new DouanesRepo_1.default(this.stitch.app, this.db.collection("douanes"), this.auth.getUser());
  };

  Repos.prototype.getMessages = function () {
    return new MessagesRepo_1.default(this.db.collection("messages"), this.auth.getUser());
  };

  Repos.prototype.getPickings = function () {
    return new PickingsRepo_1.default(this.stitch.app, this.db.collection("pickings"), this.auth.getUser());
  };

  Repos.prototype.getSyncs = function () {
    return new SyncsRepo_1.default(this.stitch.app, this.db.collection("syncs"), this.auth.getUser());
  };

  Repos.prototype.getCarriers = function () {
    return new CarriersRepo_1.default(this.stitch.app, this.db.collection("carriers"), this.auth.getUser());
  };

  return Repos;
}();

exports.default = Repos;